<template>
    <v-row no-gutters class="mt-8 mt-md-14">
        <v-col cols="12" sm="2">
            <div class="mb-2 mb-sm-0">
                <strong class="font-size-14 font-size-md-16 font-weight-medium primary--text">{{ label }}<span v-show="pointer" class="red--text">*</span></strong>
            </div>
        </v-col>
        <v-col cols="12" sm="10">
            <span class="font-size-14 font-size-md-16 grey-68--text"><slot></slot></span>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: {
        label: String,
        pointer: Boolean,
    },
};
</script>
